exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (max-width: 767px) {\n.p-mobile[data-v-52e35315] {\n    padding: 0;\n}\n.assessment-title[data-v-52e35315] {\n    background-color: #3166b0;\n    color: #fff;\n}\n}", ""]);

// exports
